import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { CameraOff } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const REGION_ID = "qr-reader-region";

export const QrScannerDialog = ({ open, onOpenChange, onScan }) => {
  const scannerRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    let active = true;

    const start = async () => {
      try {
        const html5 = new Html5Qrcode(REGION_ID);
        scannerRef.current = html5;
        await html5.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 230, height: 230 } },
          (decodedText) => {
            if (!active) return;
            active = false;
            onScan(decodedText);
            html5.stop().then(() => html5.clear()).catch(() => {});
            onOpenChange(false);
          },
          () => {}
        );
      } catch (e) {
        setError("Impossibile accedere alla fotocamera. Concedi i permessi del browser oppure usa la ricerca manuale.");
      }
    };
    start();

    return () => {
      active = false;
      const s = scannerRef.current;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open, onScan, onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-950 border-zinc-800" data-testid="qr-scanner-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Scansiona la tessera</DialogTitle>
        </DialogHeader>
        {error ? (
          <div className="flex flex-col items-center text-center gap-3 py-8">
            <CameraOff className="w-8 h-8 text-destructive" />
            <p className="text-sm text-muted-foreground">{error}</p>
          </div>
        ) : (
          <>
            <div id={REGION_ID} className="w-full overflow-hidden rounded-xl [&_video]:rounded-xl" />
            <p className="text-xs text-muted-foreground text-center mt-2">
              Inquadra il QR del cliente per aggiungere subito un timbro.
            </p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
